import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-page-v2',
  standalone: true,
  imports: [
    // HeaderComponent,
    // HeroComponent,
    // HowItWorksComponent,
    // BenefitsComponent,
    // IndustryComponent,
    // AssistantComponent,
    // AppCtaComponent,
    // FooterComponent,
  ],
  templateUrl: './landing-page-v2.component.html',
})
export class LandingPageV2Component {}
